<template>
  <b-row>
    <b-col lg="12" xl="12" class="mb-5">
      <dashboard-box :title="$t('reports.title')">
        <template v-slot:preview>
          <b-row>
            <b-col md="12">
              <highcharts :options="sendChartOptions"></highcharts>
            </b-col>
          </b-row>

          <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

          <b-row>
            <b-col md="12">
              <b-form-group class="fa-pull-right">
                <b-form-select size="sm" v-model="report_type_selected" :options="report_types"></b-form-select>
              </b-form-group>
            </b-col>
            <b-col md="12" v-if="report_type_selected == 'Yaş Raporu'">
              <highcharts :options="ageChartOptions"></highcharts>
            </b-col>
            <b-col md="12" v-if="report_type_selected == 'Şehir Raporu'">
              <highcharts :options="cityChartOptions"></highcharts>
            </b-col>
            <b-col md="12" v-if="report_type_selected == 'Cinsiyet Raporu'">
              <highcharts :options="genderChartOptions"></highcharts>
            </b-col>
          </b-row>

          <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

          <b-row class="mt-10">
            <b-col md="12">
              <highcharts :title="$t('reports.read_report_title')" :options="readChartOptions"></highcharts>
            </b-col>
          </b-row>

          <div class="separator separator-dashed separator-border-2 mb-5 mt-5"></div>

          <b-row class="mt-10">
            <b-col md="12">
              <highcharts :title="$t('reports.click_report_title')" :options="clickChartOptions"></highcharts>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </b-col>
  </b-row>
</template>

<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
import {Chart} from 'highcharts-vue'

export default {
  name: "OfferReport",
  components: {DashboardBox, highcharts: Chart},
  data() {
    return {
      ageChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.age_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: '18-24 Yaş',
            y: 30,
            sliced: true,
            selected: true
          }, {
            name: '25-34 Yaş',
            y: 60
          }, {
            name: '35-44 Yaş',
            y: 110
          }, {
            name: '45-54 Yaş',
            y: 20
          }, {
            name: '55+ Yaş',
            y: 12
          }]
        }]
      },
      cityChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.city_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: 'İstanbul',
            y: 120,
            sliced: true,
            selected: true
          }, {
            name: 'Samsun',
            y: 25
          }, {
            name: 'Balıkesir',
            y: 90
          }, {
            name: 'Gaziantep',
            y: 30
          }, {
            name: 'Ankara',
            y: 110
          }]
        }]
      },
      genderChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.gender_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#26527C','#9E8665','#151D30', '#336996', '#2970B7', '#243055', '#C8A679', '#E4C593'],
        series: [{
          name: 'Oran',
          colorByPoint: true,
          data: [{
            name: 'Kadın',
            y: 120,
            sliced: true,
            selected: true
          }, {
            name: 'Erkek',
            y: 90
          }]
        }]
      },
      sendChartOptions: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie'
        },
        title: {
          text: this.$t('reports.send_report_title')
        },
        credits: false,
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        accessibility: {
          point: {
            valueSuffix: '%'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y:.1f}'
            }
          }
        },
        colors: ['#0a6da1', '#122e5f'],
        series: [{
          name: 'Tip',
          colorByPoint: true,
          data: [{
            name: 'OPN',
            y: 130,
            sliced: true,
            selected: true
          }, {
            name: 'COPN',
            y: 120
          }]
        }]
      },
      readChartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.$t('reports.read_report_title')
        },
        xAxis: {
          categories: [
            '04.12.2020',
            '05.12.2020',
            '06.12.2020',
            '07.12.2020',
            '08.12.2020',
            '09.12.2020',
            '10.12.2020'
          ],
          crosshair: true
        },
        credits: false,
        yAxis: {
          min: 0,
          title: {
            text: this.$t('reports.number_of_read')
          },
          gridLineColor: 'transparent',
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        colors: ['#0a6da1', '#122e5f'],
        series: [{
          name: 'Tekil',
          data: [49.9, 71.5, 106.4, 129.2, 144.0, 176.0, 135.6]

        }, {
          name: 'Kümül',
          data: [83.6, 78.8, 98.5, 93.4, 106.0, 84.5, 105.0]
        }]
      },
      clickChartOptions: {
        chart: {
          type: 'column'
        },
        title: {
          text: this.$t('reports.click_report_title')
        },
        xAxis: {
          categories: [
            '04.12.2020',
            '05.12.2020',
            '06.12.2020',
            '07.12.2020',
            '08.12.2020',
            '09.12.2020',
            '10.12.2020'
          ],
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.$t('reports.number_of_click')
          },
          gridLineColor: 'transparent',
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
              '<td style="padding:0"><b>{point.y:.1f}</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        },
        credits: false,
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        colors: ['#0a6da1', '#122e5f'],
        series: [{
          name: 'Tekil',
          data: [23.9, 59.5, 85.4, 99.2, 90.0, 30.0, 45.6]

        }, {
          name: 'Kümül',
          data: [23.6, 55.8, 43.5, 20.4, 34.0, 22.5, 45.0]
        }]
      },
      report_type_selected : 'Yaş Raporu',
      report_types : ['Yaş Raporu', 'Cinsiyet Raporu', 'Şehir Raporu']
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t('general.project_1'), route: "/"},
      {title: this.$t('reports.title')}
    ]);
  }
}
</script>

<style scoped>

</style>
